import { z } from 'zod';

/**
 * Wraps a schema so it accepts `null`, `undefined`, or a missing key on input but always
 * produces `undefined` (never `null`) on output.
 *
 * Used for persisted fields that historically stored an explicit `null` to mean "absent".
 * Already-persisted data (and data written by older clients) keeps parsing, while the parsed
 * value is normalized to `undefined` to match the `T | undefined` convention used everywhere
 * else.
 */
export function undefinedFromNullish<T extends z.ZodTypeAny>(schema: T) {
  return schema.nullish().transform((value) => value ?? undefined);
}
